'use strict';

var loginBase = require('base/login/login');


var formValidation = require('../components/formValidation');
var createErrorNotification = require('base/components/errorNotification');
var kleberEmailValidation = require('../kleber/kleberEmailValidation');

    loginBase.login = function () {
        $('form.login').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            form.spinner().start();
            $('form.login').trigger('login:submit', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    form.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                        $('form.login').trigger('login:error', data);
                        form.find('input').each(function () {
                            if (!$(this).val()) {
                                $(this).focus();
                                return false;
                            }
                            return true;
                        });
                    } else {
                        $('form.login').trigger('login:success', data);
                        location.href = data.redirectUrl;
                    }
                },
                error: function (data) {
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $('form.login').trigger('login:error', data);
                        form.spinner().stop();
                    }
                }
            });
            return false;
        });
    };

    loginBase.register = function () {
        $('form.registration').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var emailField = $('form.registration #registration-form-email');
            if ($('.google-captcha-container').length > 0) {
                var recaptchaResponse = grecaptcha.getResponse();
                if (!recaptchaResponse) {
                    e.preventDefault();
                    $('.recaptcha-error').text('Please select I\'m not a robot checkbox').show();
                    return;
                }
                $('.recaptcha-error').hide();
            }

            var url = form.attr('action');

            kleberEmailValidation.isValidEmail(emailField).then(isValid => {
                if (isValid) {
                    form.spinner().start();
                    $('form.registration').trigger('login:register', e);
                    $.ajax({
                        url: url,
                        type: 'post',
                        dataType: 'json',
                        data: form.serialize(),
                        success: function (data) {
                            form.spinner().stop();
                            if (!data.success) {
                                $('form.registration').trigger('login:register:error', data);
                                formValidation(form, data);
                            } else {
                                $('form.registration').trigger('login:register:success', data);
                                location.href = data.redirectUrl;
                            }
                        },
                        error: function (err) {
                            if (err.responseJSON.redirectUrl) {
                                window.location.href = err.responseJSON.redirectUrl;
                            } else {
                                createErrorNotification($('.error-messaging'), err.responseJSON.errorMessage);
                            }
                
                            form.spinner().stop();
                        }
                    });
                }
                return false;
            });
        });
    };

    loginBase.resetPassword = function () {
        $('.reset-password-form').submit(function (e) {
            var form = $(this);
            e.preventDefault();
            var url = form.attr('action');
            var resetPasswordArea = $('#requestPasswordResetModal');
            resetPasswordArea.spinner().start();
            $('.reset-password-form').trigger('login:register', e);
            $.ajax({
                url: url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success: function (data) {
                    resetPasswordArea.spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                    } else {
                        $('.request-password-title').text(data.receivedMsgHeading);
                        $('.request-password-body').empty()
                            .append('<p>' + data.receivedMsgBody + '</p>');
                        if (!data.mobile) {
                            $('#submitEmailButton').text(data.buttonText)
                                .attr('data-dismiss', 'modal');
                        } else {
                            $('.send-email-btn').empty()
                                .html('<a href="'
                                    + data.returnUrl
                                    + '" class="btn btn-primary btn-block">'
                                    + data.buttonText + '</a>'
                                );
                        }
                    }
                },
                error: function () {
                    resetPasswordArea.spinner().stop();
                }
            });
            return false;
        });
    };

module.exports = loginBase;

